import { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import { useDrawerTransition } from '../../context/drawerProvider'
import { addData, loadData } from '../../config/data'
import {
  loadCurrentApplicantCompletion,
  loadCurrentApplicantProfile,
} from '../../config/applicantApi'
import { useDispatch, useSelector } from 'react-redux'
import '../../index.css'
import {
  setIsLogin,
  setLanguage,
  setUserName,
} from '../../redux/actions/language'
import Lang from '../../config/lang'
import ViewConfig from '../../config/viewConfig'
import { getQueryParam, setSession } from '../../config/helper'
import { useLocation, useParams } from 'react-router-dom'

const LoginPage = () => {
  const location = useLocation()
  const { jobID } = location.state || {}
  const { startTransition } = useDrawerTransition()
  const [fromPage, setfromPage] = useState(getQueryParam('from') || '')
  const mobileView = ViewConfig()
  const dispatch = useDispatch()
  const { lang } = useSelector((state) => state.globalReducer)
  const [isChecked, setIsChecked] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [isForgotPassword, setisForgotPassword] = useState(false)
  const [isRegister, setisRegister] = useState(false)
  const [isTempPassword, setIsTempPassword] = useState(false)

  const [otp, setOtp] = useState(Array(4).fill(''))

  const [otpFP, setOtpFP] = useState(Array(4).fill(''))

  const [errors, setErrors] = useState({})

  const [email, setEmail] = useState('')
  const [isLoading, setisLoading] = useState(false)

  const [password, setPassword] = useState('')
  const [isVerify, setisVerify] = useState(false)
  const [isVerified, setisVerified] = useState(false)

  //FP (Forgot Password)
  const [emailFP, setEmailFP] = useState('')
  const [passwordFP, setpasswordFP] = useState('')
  const [confirmPasswordFP, setconfirmPasswordFP] = useState('')
  const [showPasswordFP, setshowPasswordFP] = useState(null)
  const [showConfirmPasswordFP, setshowConfirmPasswordFP] = useState(null)
  const [counter, setCounter] = useState(0)

  const [candName, setCandName] = useState('')
  const [canEmail, setCanEmail] = useState('')
  const [canPhoneNumber, setCanPhoneNumber] = useState('')
  const [newpassword, setnewpassword] = useState('')
  const [confirmnewpassword, setconfirmnewpassword] = useState('')
  const [showRegPassword, setshowRegPassword] = useState(null)
  const [showRegConfirmPassword, setshowRegConfirmPassword] = useState(null)
  const [otpCodeForgotPassword, setotpCodeForgotPassword] = useState('')
  const [isSending, setisSending] = useState(false)
  const [tempApplicantID, setTempApplicantID] = useState(null)
  const [tempFullName, setTempFullName] = useState('')
  const [tempEmail, setTempEmail] = useState('')
  const [tempPassword, setTempPassword] = useState('')
  const [tempNewPassword, setTempNewPassword] = useState('')
  const [tempConfirmPassword, setTempConfirmPassword] = useState('')
  const [showTempPassword, setShowTempPassword] = useState(null)
  const [showTempConfirmPassword, setShowTempConfirmPassword] = useState(null)

  const resetAll = () => {
    setShowPassword(false)
    setisForgotPassword(false)
    setisRegister(false)
    setIsTempPassword(false)

    setOtp(Array(4).fill(''))
    setOtpFP(Array(4).fill(''))

    setErrors({})
    setEmail('')
    setisLoading(false)

    setPassword('')
    setisVerify(false)
    setisVerified(false)

    // Forgot Password
    setEmailFP('')
    setpasswordFP('')
    setconfirmPasswordFP('')
    setshowPasswordFP(null)
    setshowConfirmPasswordFP(null)
    setCounter(0)

    // Registration
    setCandName('')
    setCanEmail('')
    setCanPhoneNumber('')
    setnewpassword('')
    setconfirmnewpassword('')
    setshowRegPassword(null)
    setshowRegConfirmPassword(null)
    setotpCodeForgotPassword('')
    setisSending(false)
    setTempApplicantID(null)
    setTempFullName('')
    setTempEmail('')
    setTempPassword('')
    setTempNewPassword('')
    setTempConfirmPassword('')
    setShowTempPassword(null)
    setShowTempConfirmPassword(null)
    sessionStorage.removeItem('tempApplicantLogin')
    setIsChecked(false)
    setEmail('')
    const isRemembered = localStorage.getItem('isRemembered')
    const localEmail = localStorage.getItem('email')
    if (isRemembered === 'true' && localEmail && localEmail !== 'null') {
      setIsChecked(true)
      setEmail(localEmail)
    } else {
      localStorage.removeItem('isRemembered')
      localStorage.removeItem('email')
    }
  }

  useEffect(() => {
    const isRemembered = localStorage?.getItem('isRemembered')
    const localEmail = localStorage?.getItem('email')
    if (isRemembered === 'true' && localEmail && localEmail !== 'null') {
      setIsChecked(true)
      setEmail(localEmail)
    } else {
      localStorage.removeItem('isRemembered')
      localStorage.removeItem('email')
    }

    const tempApplicantLogin = sessionStorage?.getItem('tempApplicantLogin')
    if (tempApplicantLogin) {
      try {
        const tempApplicantData = JSON.parse(tempApplicantLogin)
        if (
          tempApplicantData?.applicantID &&
          tempApplicantData?.email &&
          tempApplicantData?.password
        ) {
          setTempApplicantID(tempApplicantData.applicantID)
          setTempFullName(tempApplicantData.fullName || '')
          setTempEmail(tempApplicantData.email)
          setTempPassword(tempApplicantData.password)
          setTempNewPassword('')
          setTempConfirmPassword('')
          setErrors({})
          setIsTempPassword(true)
          setisForgotPassword(false)
          setisRegister(false)
        }
      } catch (err) {
        sessionStorage.removeItem('tempApplicantLogin')
      }
    }
  }, [])

  const { language } = useParams()

  useEffect(() => {
    if (language) {
      dispatch(setLanguage(language))
    }
  }, [language])

  useEffect(() => {
    let timer
    if (counter > 0) {
      timer = setInterval(() => {
        setCounter((prev) => prev - 1)
      }, 1000)
    }
    return () => clearInterval(timer)
  }, [counter])

  const handleSubmitRegister = () => {
    try {
      const newErrors = {}

      if (!candName) newErrors.candName = 'full_name_required'
      if (!canPhoneNumber) newErrors.canPhoneNumber = 'phone_number_required'
      if (canPhoneNumber) {
        if (
          canPhoneNumber.charAt(0) === '0' ||
          canPhoneNumber.includes('+') ||
          canPhoneNumber.includes('-') ||
          canPhoneNumber.includes(',') ||
          canPhoneNumber.toLowerCase().includes('e') ||
          canPhoneNumber.charAt(0) === '+62' ||
          canPhoneNumber.charAt(0) === '628'
        ) {
          newErrors.canPhoneNumber = 'phone_number_format_wrong'
        }
      }
      if (!otp) newErrors.canEmail = 'please_fill_your_otp'
      if (!isVerify && !isVerified)
        newErrors.canEmail = 'please_verify_your_email'
      if (canEmail) {
        const isValid = isValidEmail(canEmail)
        if (!isValid) {
          newErrors.canEmail = 'invalid_email_format'
        }
      }
      if (!isVerified) newErrors.otp = 'please_verify_your_email'
      if (!canEmail) newErrors.canEmail = 'email_required'
      if (newpassword.length < 6) newErrors.newpassword = 'password_length'
      if (!newpassword) newErrors.newpassword = 'password_required'
      if (!confirmnewpassword) newErrors.confirmpassword = 'password_required'
      if (
        confirmnewpassword &&
        newpassword &&
        confirmnewpassword !== newpassword
      ) {
        newErrors.confirmpassword = 'password_not_match'
      }
      setErrors(newErrors)

      if (Object.keys(newErrors).length === 0) {
        setisSending(true)

        submitApplication()
      }
    } catch (error) {
      setisSending(false)
      console.log('error:', error)
    }
  }

  const submitApplication = async () => {
    try {
      const applicantPayload = {
        fullName: candName,
        email: canEmail,
        mobilePhoneNumber: `0${canPhoneNumber}`,
        resumeURL: '',
        password: newpassword,
      }
      await addData({
        url: 'Applicants',
        reqBody: applicantPayload,
      }).then(async (res) => {
        if (res?.data) {
          const applicantRes = res?.data
          await addData({
            url: 'Auth/loginCandidate',
            params: [
              { title: 'Email', value: canEmail },
              { title: 'Password', value: newpassword },
            ],
          }).then(async (loginRes) => {
            if (loginRes?.token) {
              setSession(
                applicantRes?.applicantID,
                applicantRes,
                180,
                loginRes?.token,
              )

              setisSending(false)
              setTimeout(() => {
                showAlert(Lang(lang, 'register_success'))
              }, 500)
              setTimeout(() => {
                resetAll()
                startTransition(`/${lang}/profile`, { jobID: jobID })
              }, 3000)
            } else {
              setisSending(false)
              showError(loginRes)
            }
          })
        }
      })
    } catch (error) {
      setisLoading(false)
      console.log(error)
    }
  }

  const showAlert = (action) => {
    Swal.fire({
      title: 'Success!',
      text: action || '',
      icon: 'success',
      timer: 3000,
      showConfirmButton: false,
      customClass: {
        popup: 'my-custom-popup',
      },
    })
  }

  const handleSubmit = () => {
    const newErrors = {}

    if (!email) newErrors.email = 'email_is_required'
    if (!password) newErrors.password = 'password_required'
    setErrors(newErrors)

    if (Object.keys(newErrors).length === 0) {
      submitLoginCandidate(email, password)
    }
  }

  const handleSubmitForgotPassword = () => {
    const newErrors = {}

    if (!emailFP) newErrors.emailFP = 'email_is_required'
    if (!isValidEmail(emailFP)) newErrors.emailFP = 'invalid_email_format'
    if (!passwordFP) newErrors.passwordFP = 'password_required'
    if (!isVerify && !isVerified) newErrors.emailFP = 'please_verify_your_email'
    if (isVerify && !isVerified) newErrors.otpFP = 'please_verify_your_email'
    if (!passwordFP) newErrors.passwordFP = 'password_required'
    if (!confirmPasswordFP) newErrors.confirmPasswordFP = 'password_required'

    if (passwordFP.length < 6) newErrors.passwordFP = 'password_length'
    if (!passwordFP) newErrors.passwordFP = 'password_required'
    if (passwordFP !== confirmPasswordFP)
      newErrors.confirmPasswordFP = 'password_not_match'
    if (confirmPasswordFP.length < 6)
      newErrors.confirmPasswordFP = 'password_length'
    if (!confirmPasswordFP) newErrors.confirmPasswordFP = 'password_required'
    setErrors(newErrors)

    if (Object.keys(newErrors).length === 0) {
      submitForgotPassword(emailFP, passwordFP)
    }
  }

  const handleSubmitTempPassword = () => {
    const newErrors = {}

    if (!tempNewPassword) newErrors.tempNewPassword = 'password_required'
    if (tempNewPassword.length < 6)
      newErrors.tempNewPassword = 'password_length'
    if (!tempConfirmPassword)
      newErrors.tempConfirmPassword = 'password_required'
    if (tempConfirmPassword.length < 6)
      newErrors.tempConfirmPassword = 'password_length'
    if (tempNewPassword !== tempConfirmPassword)
      newErrors.tempConfirmPassword = 'password_not_match'

    setErrors(newErrors)

    if (Object.keys(newErrors).length === 0) {
      submitTempPassword()
    }
  }

  const submitTempPassword = async () => {
    try {
      setisSending(true)
      const response = await addData({
        url: 'Auth/changeTempPassword',
        reqBody: {
          applicantID: tempApplicantID,
          email: tempEmail,
          password: tempPassword,
          newPassword: tempNewPassword,
        },
      })

      if (response?.token) {
        sessionStorage.removeItem('tempApplicantLogin')
        setisSending(false)
        showAlert(Lang(lang, 'change_password_success'))
        loadApplicant(response?.data?.applicantID, response?.token)
      } else {
        setisSending(false)
        showError(response)
      }
    } catch (error) {
      setisSending(false)
      showError(error)
    }
  }

  const submitForgotPassword = async (email, password) => {
    const newErrors = errors
    const isValid = isValidEmail(emailFP)
    if (!isValid) {
      newErrors.canEmail = 'invalid_email_format'
      setErrors(newErrors)
    } else {
      const reqBody = {
        email: email,
        newPassword: password,
        otp: otpCodeForgotPassword,
      }
      try {
        setisSending(true)
        const response = await addData({
          url: 'Applicants/ResetPassword',
          reqBody: reqBody,
        })
        if (response) {
          setisSending(false)
          setEmailFP('')
          setisVerify(false)
          setCounter(0)
          setOtpFP(Array(4).fill(''))
          setisLoading(false)
          setisVerified(false)
          setpasswordFP('')
          setconfirmPasswordFP('')
          setisRegister(false)
          setisForgotPassword(false)
          showAlert(Lang(lang, 'change_password_success'))
        }
      } catch (error) {
        setisSending(false)
        const newErrors = errors
        newErrors.canEmail = String(error)
        setErrors(newErrors)
      }
    }
  }

  const loadPercentage = async (userToken = '') => {
    const resData = await loadCurrentApplicantCompletion({ userToken })

    if (typeof resData === 'number') {
      localStorage?.setItem('profileCompletion', resData)
      if (resData === 10) {
        startTransition(`/${lang}/my-application`, { jobID: jobID })
      } else {
        startTransition(`/${lang}/profile`, { jobID: jobID })
      }
    } else {
      setisLoading(false)
      startTransition(`/${lang}/profile`, { jobID: jobID })
    }
  }

  const handleChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp]
      newOtp[index] = value
      setOtp(newOtp)

      // Auto focus ke next input
      if (value && index < otp.length - 1) {
        document.getElementById(`otp-${index + 1}`).focus()
      }
    }
  }

  const handleChangeForgotPassword = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otpFP]
      newOtp[index] = value
      setOtpFP(newOtp)

      // Auto focus ke next input
      if (value && index < otpFP.length - 1) {
        document.getElementById(`otp-${index + 1}`).focus()
      }
    }
  }

  const loadApplicant = async (applicantID, authToken = '') => {
    const resData = await loadCurrentApplicantProfile({ userToken: authToken })

    if (resData) {
      localStorage?.setItem('localProfileData', JSON.stringify(resData))
      dispatch(setUserName(resData.fullName))
      setSession(resData?.applicantID || applicantID, resData, 180, authToken)

      if (isChecked) {
        localStorage.setItem('isRemembered', true)
        localStorage.setItem('email', email)
      } else {
        const isRemembered = localStorage.getItem('isRemembered')
        const localEmail = localStorage.getItem('email')
        if (isRemembered && localEmail) {
          localStorage.removeItem('isRemembered')
          localStorage.removeItem('email')
        }
      }

      loadPercentage(authToken)
      resetAll()
    }
  }

  const submitLoginCandidate = async (email, password) => {
    setisLoading(true)

    try {
      await addData({
        url: 'Auth/loginCandidate',
        params: [
          { title: 'Email', value: email },
          { title: 'Password', value: password },
        ],
      }).then((res) => {
        if (res?.data?.isTemp === true) {
          sessionStorage.setItem(
            'tempApplicantLogin',
            JSON.stringify({
              applicantID: res?.data?.applicantID,
              fullName: res?.data?.fullName || '',
              email: email,
              password: password,
            }),
          )
          setTempApplicantID(res?.data?.applicantID)
          setTempFullName(res?.data?.fullName || '')
          setTempEmail(email)
          setTempPassword(password)
          setTempNewPassword('')
          setTempConfirmPassword('')
          setErrors({})
          setIsTempPassword(true)
          setisForgotPassword(false)
          setisRegister(false)
          setisLoading(false)
        } else if (res?.token) {
          if (res?.data) {
            const resData = res?.data
            loadApplicant(resData?.applicantID, res?.token)
          }
        } else {
          setTimeout(() => {
            showError(res)
            setisLoading(false)
          }, 500)
        }
      })
    } catch (error) {
      setisLoading(false)
      showError(error)
    }
  }

  const showError = (error) => {
    Swal.fire({
      title: 'Error!',
      text: error || Lang(lang, 'apply_job_failed'),
      icon: 'error',
      timer: 3000,
      showConfirmButton: false,
      customClass: {
        popup: 'my-custom-popup',
      },
    })
  }

  const sendOTPForgotPassword = async (email) => {
    const newErrors = errors
    const isValid = isValidEmail(emailFP)
    if (!isValid) {
      newErrors.canEmail = 'invalid_email_format'
      setErrors(newErrors)
    } else {
      try {
        const response = await addData({
          url: 'Applicants/ForgotPassword',
          params: [{ title: 'Email', value: email }],
        })
        if (response?.message === 'OTP sent successfully.') {
          setisVerify(true)
        } else {
          newErrors.emailFP = response
          setErrors(newErrors)
        }
      } catch (error) {
        const newErrors = errors
        newErrors.emailFP = String(error)
        setErrors(newErrors)
      }
    }
  }

  const sendOTP = async (name, email, companyID) => {
    const newErrors = errors
    const isValid = isValidEmail(canEmail)
    if (!isValid) {
      newErrors.canEmail = 'invalid_email_format'
      setErrors(newErrors)
    } else {
      const payload = {
        name: name,
        email: email,
        companyID: companyID,
      }
      try {
        const response = await addData({
          url: 'Candidates/SendEmailAndGenerateOTP',
          reqBody: payload,
        })
        if (`${response}`.includes('Account found')) {
          const newErrors = {}
          newErrors.canEmail = 'emailregistered'
          setErrors(newErrors)
        } else {
          setisVerify(true)
          if (!candName) newErrors.candName = 'full_name_required'
          if (!canPhoneNumber)
            newErrors.canPhoneNumber = 'phone_number_required'
          if (canPhoneNumber) {
            if (
              canPhoneNumber.charAt(0) === '0' ||
              canPhoneNumber.includes('+') ||
              canPhoneNumber.includes('-') ||
              canPhoneNumber.includes(',') ||
              canPhoneNumber.toLowerCase().includes('e') ||
              canPhoneNumber.charAt(0) === '+62' ||
              canPhoneNumber.charAt(0) === '628'
            ) {
              newErrors.canPhoneNumber = 'phone_number_format_wrong'
            }
          }
          if (!otp) newErrors.canEmail = 'please_fill_your_otp'
          if (!canEmail) newErrors.canEmail = 'email_required'

          setErrors(newErrors)
        }
      } catch (error) {
        const newErrors = errors
        newErrors.canEmail = String(error)
        setErrors(newErrors)
      }
    }
  }

  function isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return regex.test(email)
  }

  const verifyOTP = async (email, otp) => {
    setisLoading(true)

    const payload = {
      email: email,
      otpCode: otp,
    }
    const newErrors = errors

    try {
      const response = await addData({
        url: 'Candidates/VerifyOTP',
        reqBody: payload,
      })

      if (String(response).includes('Invalid')) {
        newErrors.otp = 'invalid_otp'
        setErrors(newErrors)
        setisVerified(false)
        setisLoading(false)
      } else {
        if (response) {
          const message = response.message
          if (message) {
            if (message.includes('Email verified successfully')) {
              newErrors.otp = ''
              setErrors(newErrors)
              setisLoading(false)
              setisVerified(true)
            }
          }
        } else {
          newErrors.otp = response || 'invalid_otp'
          setErrors(newErrors)
          setisVerified(false)
          setisLoading(false)
        }
      }
    } catch (error) {
      newErrors.otp = error
      setErrors(newErrors)
      setisVerified(false)
      setisLoading(false)
    }
  }

  const verifyOTPForgotPassword = async (email, otp) => {
    setisLoading(true)

    const payload = {
      email: email,
      otp: otp,
    }
    const newErrors = errors

    try {
      const response = await addData({
        url: 'Applicants/VerifyOTP',
        reqBody: payload,
      })

      if (String(response).includes('Invalid')) {
        newErrors.otpFP = 'invalid_otp'
        setErrors(newErrors)
        setisVerified(false)
        setisLoading(false)
      } else {
        if (!`${response}`.includes('invalid')) {
          if (response) {
            if (response.includes('Code:')) {
              newErrors.otpFP = ''
              setErrors(newErrors)
              setisVerified(true)
              const otpcode = response.slice(-4)
              setotpCodeForgotPassword(otpcode)
            }
            setisLoading(false)
          }
        } else {
          newErrors.otpFP = response || 'invalid_otp'
          setErrors(newErrors)
          setisVerified(false)
          setisLoading(false)
        }
      }
    } catch (error) {
      newErrors.otp = error
      setErrors(newErrors)
      setisVerified(false)
      setisLoading(false)
    }
  }

  const registerComponent = () => {
    return (
      <div className='w-full'>
        <div className='mb-3'>
          <label
            htmlhtmlFor='Name'
            className='block mb-2 text-sm md:text-sm text-gray-700 font-medium mb-1 block text-sm text-[#48494B]'
          >
            {Lang(lang, 'full_name')}
            <b className='text-[#EA2427] font-normal'>*</b>{' '}
          </label>
          <div className='relative w-full'>
            <img
              src='/asset/icon/profile_dark.svg'
              alt='profile'
              className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400'
            />
            <input
              type={'text'}
              id='Name'
              placeholder={Lang(lang, 'enter_name')}
              value={candName}
              onChange={(e) => {
                setCandName(e.target.value)
                if (Object.keys(errors).length !== 0) {
                  const newErrors = {}
                  if (!e.target.value) newErrors.candName = 'full_name_required'
                  if (!canPhoneNumber)
                    newErrors.canPhoneNumber = 'phone_number_required'
                  if (!canEmail) newErrors.canEmail = 'email_required'
                  setErrors(newErrors)
                }
              }}
              className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm border-[#48494B] `}
            />
          </div>
          {errors.candName && (
            <p className='text-red-500 text-xs mt-1'>
              {Lang(lang, errors.candName)}
            </p>
          )}
        </div>
        <div className='mb-3'>
          <label
            htmlhtmlFor='email'
            className='block mb-2 text-sm md:text-sm text-gray-700 font-medium mb-1 block text-sm text-[#48494B]'
          >
            {Lang(lang, 'phone_number')}
            <b className='text-[#EA2427] font-normal'>*</b>{' '}
          </label>
          <div className='flex flex-row rounded-l-full'>
            <div
              className={`${
                errors.canPhoneNumber ? 'border-red-500' : 'border-[#48494B]'
              } flex h-[43px] w-[60px] items-center justify-center border rounded-l-full block`}
            >
              <p className='font-medium'>{'+62'}</p>
            </div>
            <input
              type={'number'}
              id='Phone Number'
              placeholder={Lang(lang, 'enter_phone_number')}
              value={canPhoneNumber}
              onChange={(e) => {
                setCanPhoneNumber(e.target.value)
                if (Object.keys(errors).length !== 0) {
                  const newErrors = {}
                  if (!candName) newErrors.candName = 'full_name_required'
                  if (e.target.value) {
                    if (
                      e.target.value.charAt(0) === '0' ||
                      canPhoneNumber.includes('+') ||
                      canPhoneNumber.includes('-') ||
                      canPhoneNumber.includes(',') ||
                      canPhoneNumber.toLowerCase().includes('e') ||
                      canPhoneNumber.charAt(0) === '+62' ||
                      canPhoneNumber.charAt(0) === '628'
                    ) {
                      newErrors.canPhoneNumber = 'phone_number_format_wrong'
                    }
                  }
                  if (!e.target.value)
                    newErrors.canPhoneNumber = 'phone_number_required'

                  if (!canEmail) newErrors.canEmail = 'email_required'
                  setErrors(newErrors)
                }
              }}
              className={`pl-3 pr-4 py-2 border rounded-r-full border-[#48494B] w-full h-[43px] text-sm text-[#48494B] block`}
            />
          </div>
          {errors.canPhoneNumber && (
            <p className='text-red-500 text-xs mt-1'>
              {Lang(lang, errors.canPhoneNumber)}
            </p>
          )}
        </div>
        <div className='mb-3'>
          <label
            htmlhtmlFor='email'
            className='block mb-2 text-sm md:text-sm text-gray-700 font-medium mb-1 block text-sm text-[#48494B]'
          >
            Email
            <b className='text-[#EA2427] font-normal'>
              {' '}
              ({Lang(lang, 'please_verify_before_continuing')})*
            </b>{' '}
          </label>

          {isVerify && !isVerified && (
            <div>
              <p className='text-gray-500 text-sm'>
                {Lang(lang, 'we_sent_otp_to_email')} <br />
                <span className='font-medium'>{emailFP}</span>
              </p>

              <div className='flex justify-center md:justify-start items-center gap-3 mt-3 mb-5 md:mb-3 w-full flex-wrap'>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type='number'
                    maxLength='1'
                    value={digit}
                    onChange={(e) => {
                      handleChange(e.target.value, index)
                    }}
                    className='w-[60px] h-[60px] text-center border rounded-lg text-xl focus:ring-2 focus:ring-blue-500 outline-none'
                  />
                ))}

                {!isVerified && (
                  <button
                    className={`rounded-full ${otp.join('').length === 4 ? 'bg-red-500' : 'bg-gray-300'} text-white px-4 py-2 font-medium md:text-sm text-xs`}
                    onClick={(e) => {
                      e.preventDefault()
                      if (!isLoading && otp.join('').length === 4) {
                        verifyOTP(canEmail, otp.join(''))
                      }
                    }}
                  >
                    {isLoading ? (
                      <div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto'></div>
                    ) : (
                      Lang(lang, 'verify')
                    )}
                  </button>
                )}
              </div>

              {errors.otp && (
                <p className='text-red-500 text-xs mt-1 mb-3'>
                  {Lang(lang, errors.otp) || errors.otp}
                </p>
              )}
            </div>
          )}

          <div className='relative flex items-center border rounded-full overflow-hidden'>
            <div className={`relative w-full`}>
              <img
                src='/asset/icon/email.svg'
                alt='email'
                className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400'
              />
              <input
                type='email'
                id='email'
                placeholder={Lang(lang, 'enter_email')}
                value={canEmail}
                onChange={(e) => {
                  setCanEmail(e.target.value)
                  setisVerified(false)
                  setisVerify(false)
                  setCounter(0)
                  setOtp(Array(4).fill(''))
                  if (Object.keys(errors).length !== 0) {
                    const newErrors = {}
                    if (!candName) newErrors.candName = 'full_name_required'
                    if (!canPhoneNumber)
                      newErrors.canPhoneNumber = 'phone_number_required'
                    if (!e.target.value) newErrors.canEmail = 'email_required'
                    setErrors(newErrors)
                  }
                }}
                className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm border-[#48494B]`}
              />
            </div>
            {isVerified ? (
              <img
                className='w-[25px] absolute right-3 md:right-5'
                src={'/asset/icon/check_green.svg'}
              />
            ) : (
              <button
                className={`rounded-full absolute ${canEmail && isValidEmail(canEmail) && canEmail && canPhoneNumber && candName ? 'bg-red-500' : 'bg-gray-300'} text-white px-4 py-1 font-medium right-3 md:text-sm text-xs`}
                onClick={(e) => {
                  e.preventDefault()
                  if (
                    canEmail &&
                    counter === 0 &&
                    isValidEmail(canEmail) &&
                    canEmail &&
                    canPhoneNumber &&
                    candName
                  ) {
                    setCounter(120)
                    sendOTP(candName, canEmail, 2)
                  }
                }}
              >
                {counter > 0
                  ? `${Math.floor(counter / 60)}:${String(counter % 60).padStart(2, '0')}`
                  : isVerify
                    ? Lang(lang, 'resend')
                    : Lang(lang, 'verify')}
              </button>
            )}
          </div>
          {errors.canEmail && (
            <p className='text-red-500 text-xs mt-1'>
              {Lang(lang, errors.canEmail)}
            </p>
          )}
        </div>
        <div>
          {isVerified && (
            <div className='mb-4 w-full'>
              <div className='mb-4 w-full'>
                <label
                  htmlFor='password'
                  className='text-sm text-gray-700 font-medium mb-1 block'
                >
                  {Lang(lang, 'password')}{' '}
                  <b className='text-[#EA2427] font-normal'>
                    {' '}
                    ({Lang(lang, 'set_password')})*
                  </b>
                </label>
                <div className='relative'>
                  <img
                    src='/asset/icon/password.svg'
                    alt='password'
                    className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400'
                  />
                  <input
                    type={showRegPassword ? 'text' : 'password'}
                    id='password'
                    placeholder={Lang(lang, 'enter_new_password')}
                    value={newpassword}
                    onChange={(e) => {
                      setnewpassword(e.target.value)

                      if (Object.keys(errors).length !== 0) {
                        const newErrors = {}
                        if (!candName) newErrors.candName = 'full_name_required'
                        if (!canPhoneNumber)
                          newErrors.canPhoneNumber = 'phone_number_required'
                        if (!canEmail) newErrors.canEmail = 'email_required'
                        if (!isVerify && !isVerified)
                          newErrors.canEmail = 'please_verify_your_email'
                        if (canEmail) {
                          const isValid = isValidEmail(canEmail)
                          if (!isValid) {
                            newErrors.canEmail = 'invalid_email_format'
                          }
                        }
                        if (!isVerified)
                          newErrors.otp = 'please_verify_your_email'
                        if (!canEmail) newErrors.canEmail = 'email_required'
                        if (e.target.value.length < 6)
                          newErrors.newpassword = 'password_length'
                        if (!e.target.value)
                          newErrors.newpassword = 'password_required'
                        if (!confirmnewpassword)
                          newErrors.confirmpassword = 'password_required'
                        if (
                          confirmnewpassword &&
                          newpassword &&
                          confirmnewpassword !== newpassword
                        ) {
                          newErrors.confirmpassword = 'password_not_match'
                        }
                        setErrors(newErrors)
                      }
                    }}
                    className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm ${errors.password ? 'border-red-500' : 'border-[#48494B]'}`}
                  />
                  <a
                    href=''
                    onClick={(e) => {
                      e.preventDefault()
                      setshowRegPassword(!showRegPassword)
                    }}
                  >
                    <img
                      src={
                        showRegPassword
                          ? '/asset/icon/eye_close.svg'
                          : '/asset/icon/eye.svg'
                      }
                      alt='show'
                      className='absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 cursor-pointer'
                    />
                  </a>
                </div>

                {errors.newpassword && (
                  <p className='text-red-500 text-xs mt-1'>
                    {Lang(lang, errors.newpassword)}
                  </p>
                )}
              </div>
              <label
                htmlFor='password'
                className='text-sm text-gray-700 font-medium mb-1 block'
              >
                {Lang(lang, 'confirm_password')}
                <b className='text-[#EA2427] font-normal'>*</b>
              </label>
              <div className='relative'>
                <img
                  src='/asset/icon/password.svg'
                  alt='confirm password'
                  className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400'
                />
                <input
                  type={showRegConfirmPassword ? 'text' : 'password'}
                  id='password'
                  placeholder={Lang(lang, 'confirm_new_password')}
                  value={confirmnewpassword}
                  onChange={(e) => {
                    setconfirmnewpassword(e.target.value)

                    if (Object.keys(errors).length !== 0) {
                      const newErrors = {}
                      if (!candName) newErrors.candName = 'full_name_required'
                      if (!canPhoneNumber)
                        newErrors.canPhoneNumber = 'phone_number_required'
                      if (!canEmail) newErrors.canEmail = 'email_required'
                      if (!isVerify && !isVerified)
                        newErrors.canEmail = 'please_verify_your_email'
                      if (canEmail) {
                        const isValid = isValidEmail(canEmail)
                        if (!isValid) {
                          newErrors.canEmail = 'invalid_email_format'
                        }
                      }
                      if (!isVerified)
                        newErrors.otp = 'please_verify_your_email'
                      if (!canEmail) newErrors.canEmail = 'email_required'
                      if (!newpassword)
                        newErrors.newpassword = 'password_required'
                      if (newpassword.length < 6)
                        newErrors.newpassword = 'password_length'
                      if (!e.target.value)
                        newErrors.confirmpassword = 'password_required'
                      if (
                        e.target.value &&
                        newpassword &&
                        e.target.value !== newpassword
                      ) {
                        newErrors.confirmpassword = 'password_not_match'
                      }
                      setErrors(newErrors)
                    }
                  }}
                  className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm ${errors.password ? 'border-red-500' : 'border-[#48494B]'}`}
                />
                <a
                  href=''
                  onClick={(e) => {
                    e.preventDefault()
                    setshowRegConfirmPassword(!showRegConfirmPassword)
                  }}
                >
                  <img
                    src={
                      showRegConfirmPassword
                        ? '/asset/icon/eye_close.svg'
                        : '/asset/icon/eye.svg'
                    }
                    alt='show'
                    className='absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 cursor-pointer'
                  />
                </a>
              </div>

              {errors.confirmpassword && (
                <p className='text-red-500 text-xs mt-1'>
                  {Lang(lang, errors.confirmpassword)}
                </p>
              )}
            </div>
          )}
        </div>
        <div className='flex flex-row gap-2 mt-5'>
          <button
            className='w-full bg-gray-10 hover:bg-gray-50 font-semibold py-2 rounded-full border border-red-500 text-red-500'
            onClick={() => {
              setisRegister(false)
            }}
          >
            {Lang(lang, 'back')}
          </button>

          <button
            className='w-full bg-red-500 hover:bg-red-600 text-white font-semibold py-2 rounded-full'
            onClick={() => {
              if (!isSending) {
                handleSubmitRegister()
              }
            }}
          >
            {isSending ? (
              <div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto'></div>
            ) : (
              Lang(lang, 'continue')
            )}
          </button>
        </div>
      </div>
    )
  }

  const changePassword = () => {
    return (
      <div className='w-full'>
        <div className='mb-6'>
          <label
            htmlhtmlFor='email'
            className='block mb-2 text-sm md:text-sm text-gray-700 font-medium mb-1 block text-sm text-[#48494B]'
          >
            Email
            <b className='text-[#EA2427] font-normal'>
              {' '}
              ({Lang(lang, 'please_verify_before_continuing')})*
            </b>{' '}
          </label>

          {isVerify && !isVerified && (
            <div>
              <p className='text-gray-500 text-sm'>
                {Lang(lang, 'we_sent_otp_to_email')} <br />
                <span className='font-medium'>{emailFP}</span>
              </p>

              <div className='flex justify-center md:justify-start items-center gap-3 mt-3 mb-5 md:mb-3 w-full flex-wrap'>
                {otpFP.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type='number'
                    maxLength='1'
                    value={digit}
                    onChange={(e) => {
                      handleChangeForgotPassword(e.target.value, index)
                    }}
                    className='w-[60px] h-[60px] text-center border rounded-lg text-xl focus:ring-2 focus:ring-blue-500 outline-none'
                  />
                ))}

                {!isVerified && (
                  <button
                    className={`rounded-full ${otpFP.join('').length === 4 ? 'bg-red-500' : 'bg-gray-300'} text-white px-4 py-2 font-medium md:text-sm text-xs`}
                    onClick={(e) => {
                      e.preventDefault()
                      if (!isLoading && otpFP.join('').length === 4) {
                        verifyOTPForgotPassword(emailFP, otpFP.join(''))
                      }
                    }}
                  >
                    {isLoading ? (
                      <div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto'></div>
                    ) : (
                      Lang(lang, 'verify')
                    )}
                  </button>
                )}
              </div>

              {errors.otpFP && (
                <p className='text-red-500 text-xs mt-1 mb-3'>
                  {Lang(lang, errors.otpFP) || errors.otpFP}
                </p>
              )}
            </div>
          )}

          <div className='relative flex items-center border rounded-full overflow-hidden'>
            <div className={`relative w-full`}>
              <img
                src='/asset/icon/email.svg'
                alt='email'
                className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400'
              />
              <input
                type='email'
                id='email'
                placeholder={Lang(lang, 'enter_email')}
                value={emailFP}
                onChange={(e) => {
                  setEmailFP(e.target.value)
                  const newErrors = {}
                  if (!emailFP) newErrors.emailFP = 'email_required'
                  setisVerify(false)
                  setCounter(0)
                  setOtpFP(Array(4).fill(''))
                  setisLoading(false)
                  setisVerified(false)
                  setpasswordFP('')
                  setconfirmPasswordFP('')
                  if (Object.keys(errors).length !== 0) {
                    const newErrors = {}
                    if (!e.target.value)
                      newErrors.e.target.value = 'email_required'
                    setErrors(newErrors)
                  }
                }}
                className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm border-[#48494B]`}
              />
            </div>
            {isVerified ? (
              <img
                className='w-[25px] absolute right-3 md:right-5'
                src={'/asset/icon/check_green.svg'}
              />
            ) : (
              <button
                className={`rounded-full absolute ${emailFP && isValidEmail(emailFP) && counter === 0 ? 'bg-red-500' : 'bg-gray-300'} text-white px-4 py-1 font-medium right-3 md:text-sm text-xs`}
                onClick={(e) => {
                  e.preventDefault()
                  if (emailFP && counter === 0 && isValidEmail(emailFP)) {
                    setCounter(120)
                    sendOTPForgotPassword(emailFP)
                  }
                }}
              >
                {counter > 0
                  ? `${Math.floor(counter / 60)}:${String(counter % 60).padStart(2, '0')}`
                  : isVerify
                    ? Lang(lang, 'resend')
                    : Lang(lang, 'verify')}
              </button>
            )}
          </div>
          {errors.emailFP && (
            <p className='text-red-500 text-xs mt-1'>
              {Lang(lang, errors.emailFP) || errors.emailFP}
            </p>
          )}
        </div>
        {isVerified && (
          <div>
            <div className='mb-4 w-full'>
              <label
                htmlFor='password'
                className='text-sm text-gray-700 font-medium mb-1 block'
              >
                {Lang(lang, 'new_password')}
                <b className='text-[#EA2427] font-normal'>
                  {' '}
                  ({Lang(lang, 'set_password')})*
                </b>
              </label>
              <div className='relative'>
                <img
                  src='/asset/icon/password.svg'
                  alt='password'
                  className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400'
                />
                <input
                  type={showPasswordFP ? 'text' : 'password'}
                  id='password'
                  placeholder={Lang(lang, 'enter_new_password')}
                  value={passwordFP}
                  onChange={(e) => {
                    setpasswordFP(e.target.value)
                    const newErrors = {}
                    if (e.target.value.length < 6)
                      newErrors.passwordFP = 'password_length'
                    if (!e.target.value)
                      newErrors.passwordFP = 'password_required'
                    if (confirmPasswordFP.length < 6)
                      newErrors.confirmPasswordFP = 'password_length'
                    if (!confirmPasswordFP)
                      newErrors.confirmPasswordFP = 'password_required'
                    setErrors(newErrors)
                  }}
                  className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm border-[#48494B]`}
                />
                <a
                  href=''
                  onClick={(e) => {
                    e.preventDefault()
                    setshowPasswordFP(!showPassword)
                  }}
                >
                  <img
                    src={
                      showPasswordFP
                        ? '/asset/icon/eye_close.svg'
                        : '/asset/icon/eye.svg'
                    }
                    alt='show'
                    className='absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 cursor-pointer'
                  />
                </a>
              </div>

              {errors.passwordFP && (
                <p className='text-red-500 text-xs mt-1'>
                  {Lang(lang, errors.passwordFP)}
                </p>
              )}
            </div>
            <div className='mb-4 w-full'>
              <label
                htmlFor='password'
                className='text-sm text-gray-700 font-medium mb-1 block'
              >
                {Lang(lang, 'confirm_new_password')}
              </label>
              <div className='relative'>
                <img
                  src='/asset/icon/password.svg'
                  alt='password'
                  className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400'
                />
                <input
                  type={showConfirmPasswordFP ? 'text' : 'password'}
                  id='password'
                  placeholder={Lang(lang, 'confirm_new_password')}
                  value={confirmPasswordFP}
                  onChange={(e) => {
                    setconfirmPasswordFP(e.target.value)
                    const newErrors = {}
                    if (passwordFP.length < 6)
                      newErrors.passwordFP = 'password_length'
                    if (!passwordFP) newErrors.passwordFP = 'password_required'
                    if (passwordFP === confirmPasswordFP)
                      newErrors.confirmPasswordFP = 'password_not_match'
                    if (e.target.value.length < 6)
                      newErrors.confirmPasswordFP = 'password_length'
                    if (!e.target.value)
                      newErrors.confirmPasswordFP = 'password_required'
                    setErrors(newErrors)
                  }}
                  className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm border-[#48494B]`}
                />
                <a
                  href=''
                  onClick={(e) => {
                    e.preventDefault()
                    setshowConfirmPasswordFP(!showPassword)
                  }}
                >
                  <img
                    src={
                      showConfirmPasswordFP
                        ? '/asset/icon/eye_close.svg'
                        : '/asset/icon/eye.svg'
                    }
                    alt='show'
                    className='absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 cursor-pointer'
                  />
                </a>
              </div>

              {errors.confirmPasswordFP && (
                <p className='text-red-500 text-xs mt-1'>
                  {Lang(lang, errors.confirmPasswordFP)}
                </p>
              )}
            </div>
          </div>
        )}
        <div className='flex flex-row gap-2 mt-5'>
          <button
            className='w-full bg-gray-10 hover:bg-gray-50 font-semibold py-2 rounded-full border border-red-500 text-red-500'
            onClick={() => {
              setisForgotPassword(false)
            }}
          >
            {Lang(lang, 'back')}
          </button>

          <button
            className='w-full bg-red-500 hover:bg-red-600 text-white font-semibold py-2 rounded-full'
            onClick={() => {
              if (!isSending) {
                handleSubmitForgotPassword()
              }
            }}
          >
            {isSending ? (
              <div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto'></div>
            ) : (
              Lang(lang, 'continue')
            )}
          </button>
        </div>
      </div>
    )
  }

  const changeTempPassword = () => {
    return (
      <form
        className='w-full'
        onSubmit={(e) => {
          e.preventDefault()
          if (!isSending) {
            handleSubmitTempPassword()
          }
        }}
      >
        <p className='mb-5 text-sm text-[#4B5563]'>
          {Lang(lang, 'hello')}{' '}
          <span className='font-semibold text-[#111827]'>
            {tempFullName || tempEmail}
          </span>
          , {Lang(lang, 'temp_password_change_desc')}
        </p>
        <div className='mb-4 w-full'>
          <label
            htmlFor='tempNewPassword'
            className='text-sm text-gray-700 font-medium mb-1 block'
          >
            {Lang(lang, 'new_password')}
            <b className='text-[#EA2427] font-normal'>*</b>
          </label>
          <div className='relative'>
            <img
              src='/asset/icon/password.svg'
              alt='password'
              className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400'
            />
            <input
              type={showTempPassword ? 'text' : 'password'}
              id='tempNewPassword'
              placeholder={Lang(lang, 'enter_new_password')}
              value={tempNewPassword}
              onChange={(e) => {
                setTempNewPassword(e.target.value)
                const newErrors = {}
                if (e.target.value.length < 6)
                  newErrors.tempNewPassword = 'password_length'
                if (!e.target.value)
                  newErrors.tempNewPassword = 'password_required'
                if (
                  tempConfirmPassword &&
                  e.target.value !== tempConfirmPassword
                )
                  newErrors.tempConfirmPassword = 'password_not_match'
                setErrors(newErrors)
              }}
              className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm border-[#48494B]`}
            />
            <a
              href=''
              onClick={(e) => {
                e.preventDefault()
                setShowTempPassword(!showTempPassword)
              }}
            >
              <img
                src={
                  showTempPassword
                    ? '/asset/icon/eye_close.svg'
                    : '/asset/icon/eye.svg'
                }
                alt='show'
                className='absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 cursor-pointer'
              />
            </a>
          </div>

          {errors.tempNewPassword && (
            <p className='text-red-500 text-xs mt-1'>
              {Lang(lang, errors.tempNewPassword)}
            </p>
          )}
        </div>
        <div className='mb-4 w-full'>
          <label
            htmlFor='tempConfirmPassword'
            className='text-sm text-gray-700 font-medium mb-1 block'
          >
            {Lang(lang, 'confirm_new_password')}
          </label>
          <div className='relative'>
            <img
              src='/asset/icon/password.svg'
              alt='password'
              className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400'
            />
            <input
              type={showTempConfirmPassword ? 'text' : 'password'}
              id='tempConfirmPassword'
              placeholder={Lang(lang, 'confirm_new_password')}
              value={tempConfirmPassword}
              onChange={(e) => {
                setTempConfirmPassword(e.target.value)
                const newErrors = {}
                if (tempNewPassword.length < 6)
                  newErrors.tempNewPassword = 'password_length'
                if (!tempNewPassword)
                  newErrors.tempNewPassword = 'password_required'
                if (e.target.value.length < 6)
                  newErrors.tempConfirmPassword = 'password_length'
                if (!e.target.value)
                  newErrors.tempConfirmPassword = 'password_required'
                if (tempNewPassword && e.target.value !== tempNewPassword)
                  newErrors.tempConfirmPassword = 'password_not_match'
                setErrors(newErrors)
              }}
              className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm border-[#48494B]`}
            />
            <a
              href=''
              onClick={(e) => {
                e.preventDefault()
                setShowTempConfirmPassword(!showTempConfirmPassword)
              }}
            >
              <img
                src={
                  showTempConfirmPassword
                    ? '/asset/icon/eye_close.svg'
                    : '/asset/icon/eye.svg'
                }
                alt='show'
                className='absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 cursor-pointer'
              />
            </a>
          </div>

          {errors.tempConfirmPassword && (
            <p className='text-red-500 text-xs mt-1'>
              {Lang(lang, errors.tempConfirmPassword)}
            </p>
          )}
        </div>
        <div className='flex flex-row gap-2 mt-5'>
          <button
            type='button'
            className='w-full bg-gray-10 hover:bg-gray-50 font-semibold py-2 rounded-full border border-red-500 text-red-500'
            onClick={() => {
              setIsTempPassword(false)
              setTempApplicantID(null)
              setTempFullName('')
              setTempEmail('')
              setTempPassword('')
              setTempNewPassword('')
              setTempConfirmPassword('')
              sessionStorage.removeItem('tempApplicantLogin')
              setErrors({})
            }}
          >
            {Lang(lang, 'back')}
          </button>

          <button
            type='submit'
            className='w-full bg-red-500 hover:bg-red-600 text-white font-semibold py-2 rounded-full'
          >
            {isSending ? (
              <div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto'></div>
            ) : (
              Lang(lang, 'continue')
            )}
          </button>
        </div>
      </form>
    )
  }

  return (
    <div
      className={
        mobileView
          ? 'relative flex flex-col w-screen h-screen'
          : 'flex w-screen h-screen'
      }
    >
      <div className='flex flex-1'>
        <img
          src={
            mobileView
              ? '/asset/images/bg_mobile.svg'
              : '/asset/images/login_background.webp'
          }
          className={
            mobileView
              ? 'absolute w-full h-full object-cover'
              : 'w-full h-full object-cover'
          }
          alt='background'
        />
      </div>
      <div
        className={
          mobileView
            ? 'rounded-t-3xl relative bg-white flex flex-1 items-center justify-center'
            : 'bg-white flex flex-1 items-center justify-center'
        }
      >
        <div
          className='bg-white flex items-start pb-10 pt-4 px-4 md:p-4 md:max-w-[512px] rounded-lg mx-auto my-auto'
          style={{ boxShadow: '0px 0px 6px 2px rgb(0 118 255 / 15%)' }}
        >
          <div className='flex flex-col gap-4 items-center w-full'>
            <div className='w-[28%] mx-auto mt-10'>
              <img src='/asset/logosopra_high.png' />
            </div>
            <p className='text-[16px] text-[#4B5563]'>
              {isRegister
                ? Lang(lang, 'register_to_proceed')
                : isForgotPassword
                  ? Lang(lang, 'change_password')
                  : isTempPassword
                    ? Lang(lang, 'change_password')
                    : fromPage === 'portal'
                      ? Lang(lang, 'login_to_apply_desc')
                      : Lang(lang, 'sign_in_desc')}
            </p>
            {isRegister ? (
              registerComponent()
            ) : isForgotPassword ? (
              changePassword()
            ) : isTempPassword ? (
              changeTempPassword()
            ) : (
              <form
                className='w-full'
                onSubmit={(e) => {
                  e.preventDefault()
                  handleSubmit()
                }}
              >
                <div className='mb-4 w-full'>
                  <label
                    htmlFor='email'
                    className='text-sm text-gray-700 font-medium mb-1 block'
                  >
                    {Lang(lang, 'email_address')}
                  </label>
                  <div className={`relative w-full`}>
                    <img
                      src='/asset/icon/email.svg'
                      alt='email'
                      className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400'
                    />
                    <input
                      type='email'
                      id='email'
                      placeholder={Lang(lang, 'enter_email')}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm ${errors.email ? 'border-red-500' : 'border-[#48494B]'}`}
                    />
                  </div>

                  {errors.email && (
                    <p className='text-red-500 text-xs mt-1'>
                      {Lang(lang, errors.email)}
                    </p>
                  )}
                </div>
                <div className='mb-4 w-full'>
                  <label
                    htmlFor='password'
                    className='text-sm text-gray-700 font-medium mb-1 block'
                  >
                    {Lang(lang, 'password')}
                  </label>
                  <div className='relative'>
                    <img
                      src='/asset/icon/password.svg'
                      alt='password'
                      className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400'
                    />
                    <input
                      type={showPassword ? 'text' : 'password'}
                      id='password'
                      placeholder={Lang(lang, 'enter_password')}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className={`pl-10 pr-4 py-2 border rounded-full w-full h-[43px] text-sm  border-[#48494B]`}
                    />
                    <a
                      href=''
                      onClick={(e) => {
                        e.preventDefault()
                        setShowPassword(!showPassword)
                      }}
                    >
                      <img
                        src={
                          showPassword
                            ? '/asset/icon/eye_close.svg'
                            : '/asset/icon/eye.svg'
                        }
                        alt='show'
                        className='absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 cursor-pointer'
                      />
                    </a>
                  </div>

                  {errors.password && (
                    <p className='text-red-500 text-xs mt-1'>
                      {Lang(lang, errors.password)}
                    </p>
                  )}
                </div>
                <div className='flex justify-between items-center text-sm mb-6 w-full'>
                  <label className='flex items-center space-x-2'>
                    <input
                      type='checkbox'
                      className='form-checkbox text-red-500'
                      checked={isChecked}
                      onChange={(e) => {
                        setIsChecked(!isChecked)
                      }}
                    />
                    <span className='text-gray-700'>
                      {Lang(lang, 'remember_me')}
                    </span>
                  </label>
                  <a
                    href=''
                    onClick={(e) => {
                      e.preventDefault()
                      resetAll()
                      setisForgotPassword(true)
                    }}
                  >
                    <span className='text-gray-700 underline'>
                      {Lang(lang, 'forget_password')}?
                    </span>
                  </a>
                </div>

                <button
                  type='submit'
                  className='bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-10 rounded-full flex mx-auto'
                >
                  {isLoading ? (
                    <div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto'></div>
                  ) : (
                    Lang(lang, 'login')
                  )}
                </button>

                <div className='flex flex-row justify-center items-center mt-5'>
                  <label
                    htmlFor='message'
                    className='block text-xs md:text-[12px] mt-1 font-medium text-[#48494B]'
                  >
                    {Lang(lang, 'dont_have_an_account')}
                  </label>
                  <a
                    href=''
                    className='ml-3 font-bold text-[#EA2427] underline text-[14px]'
                    onClick={(e) => {
                      e.preventDefault()
                      resetAll()
                      setisRegister(true)
                    }}
                  >
                    {Lang(lang, 'register')}
                  </a>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
